import { createApiClient } from '@lib/api/api';

import type { IUser } from '@typings/IUser';

interface IApiUserAuthResult {
    user: IUser | null;
    token: string;
    uuid: string;
}

async function getToken(userdata: string | undefined): Promise<IApiUserAuthResult> {
    const anonymousApiRequest = createApiClient(undefined);

    const session = await anonymousApiRequest<IApiUserAuthResult>('GET', 'users/session', { userdata });

    return session;
}

export async function trySession() {
    const userdata = Telegram.WebApp.initData || undefined;

    const {
        user,
        token,
        uuid,
    } = await getToken(userdata);

    return {
        apiRequest: createApiClient(token),
        user,
        uuid,
    };
}
